import { useToast } from "@mallardbay/lib-react-components"

import COPY_CONSTANTS from "~config/copy-constants"
import type {
    QuoteRequestFieldsFragment,
    QuoteRequestInput,
} from "~graphql/generated/graphql"
import { useCreateQuoteRequestMutation } from "~graphql/generated/graphql"
import { trackQuoteRequested } from "~utils/event-tracking/event-tracking-helpers"
import type { QuoteRequestedParams } from "~utils/event-tracking/event-tracking-types"

export function useCreateQuoteRequest({
    onSuccess,
}: {
    onSuccess?: () => void
}) {
    const { showError, showSuccess } = useToast()
    const [createQuoteRequestMutation, { loading, error }] =
        useCreateQuoteRequestMutation({
            onCompleted: (data) => {
                showSuccess(COPY_CONSTANTS.QUOTE_REQUEST_SUCCESS)
                trackQuoteRequestCreated(data.createQuoteRequest)
                onSuccess?.()
            },
            onError: (errorResponse) => {
                showError(errorResponse)
            },
        })

    const createQuoteRequest = async (data: QuoteRequestInput) => {
        return createQuoteRequestMutation({ variables: { data } })
    }

    return { createQuoteRequest, isLoading: loading, error }
}

function trackQuoteRequestCreated(quoteRequest: QuoteRequestFieldsFragment) {
    const params: QuoteRequestedParams = {
        contact_first_name: quoteRequest.contact.first_name,
        contact_last_name: quoteRequest.contact.last_name,
        contact_email: quoteRequest.contact.email,
        contact_phone: quoteRequest.contact.phone ?? undefined,
        listing_id: quoteRequest.listing?.id ?? "",
        preferred_dates: quoteRequest.dates,
        trip_details: quoteRequest.trip_details,
    }

    trackQuoteRequested(params)
}
